export const escapeIncompatibleMupPattern = (regex) => {
    var _a, _b;
    return (_b = (_a = regex === null || regex === void 0 ? void 0 : regex.replace(/\[ \|-]/g, '[ \\-]') // phone numbers
    ) === null || _a === void 0 ? void 0 : _a.replace(/\[-\| ]/g, '[ \\-]') // phone numbers
    ) === null || _b === void 0 ? void 0 : _b.replace(/\*\+\/=\?\^_`~-/g, '*+\\/=?^_`~\\-');
}; // email
